import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const KesennumaCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      })}
    >
      <Heading>
        {t("みやぎポイント(けせんぬま生活応援ポイント)の給付について")}
      </Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t(
          "気仙沼市では物価高騰対策の一つとして、ポケットサインをインストールしている19歳以上（平成19年4月1日以前生まれ）の気仙沼市民の皆様に5,000ポイントをプレゼントするキャンペーンを実施しています。",
        )}
        <br />
        <br />
        {t(
          "「応募する」ボタンからみやぎ防災ミニアプリに登録のうえポイントを受け取っていただくと、ただちにポイントが付与され、対象店舗で1ポイント＝1円として使用（使用期限は令和8年11月30日まで）できます。キャンペーンは令和8年3月31日までですので、お忘れなくお受け取りください。",
        )}
      </p>
    </div>
  );
};
